import { Checkbox, Col, Form, Input, InputNumber, Row, Select, Typography } from "antd";
import { useIntl } from "react-intl";
import { createMaxPlayersValidator } from "~Features/MatchProfiles/shared/maxPlayersValidator";
import {MatchProfileNumberFormInput} from "~Features/MatchProfiles/shared/MatchProfileNumberFormInput";
import { noLeadingOrTrailingSpacesRule } from "~utils/noLeadingOrTrailingSpacesRule.ts";

const checkboxOptions = [
  { value: 1, label: "P1" },
  { value: 2, label: "P2" },
  { value: 3, label: "P3" },
  { value: 4, label: "P4" },
  { value: 11, label: "OT1" },
  { value: 12, label: "OT2" },
  { value: 13, label: "OT3" },
  { value: 14, label: "OT4" },
  { value: 15, label: "OT5" },
  { value: 16, label: "OT6" },
];


const HockeyForm = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Row>
        <Col span={8}>
          <Form.Item
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 16 }}
            required={true}
            name={"name"}
            rules={[
              {
                required: true,
                message: "Please input name",
              },
              {
                min: 2,
                message: formatMessage({ id: "form.validation.min.length" }, { length: 2 }),
              },
              noLeadingOrTrailingSpacesRule(formatMessage),
            ]}
            label={formatMessage({
              id: "name",
              defaulMessage: "Name",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.name",
              defaultMessage: "Name of the match profile",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"defaultProfile"}
            label={formatMessage({
              id: "defaultProfile",
              defaulMessage: "Default Profile",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.default",
              defaultMessage: "Is this the default profile for the organization?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={4}>Profile</Typography.Title>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"numberOfPeriods"}
            label={formatMessage({
              id: "number.of.periods",
              defaultMessage: "numberOfPeriods",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.number.of.periods",
              defaultMessage: "The number of regular periods to play",
            })}
          >
            <InputNumber
              style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"periodLength"}
            label={formatMessage({
              id: "period.length",
              defaultMessage: "periodLength",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.period.length",
              defaultMessage: "The length (in minutes) of a regular period",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"halfTimeDuration"}
            label={formatMessage({
              id: "half.time.duration",
              defaultMessage: "Half Time duration (in minutes)",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.half.time",
              defaultMessage: "The length (in minutes) of a half time break",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"periodBreakDuration"}
            label={formatMessage({
              id: "period.break.duration",
              defaultMessage: "Period Break duration (in minutes)",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.period.break",
              defaultMessage: "The length (in minutes) of a break between periods",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"maximumRosterSize"}
            label={formatMessage({
              id: "maximum.roster.size",
              defaultMessage: "maximumRosterSize",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.max.roster.size",
              defaultMessage: "The maximum number of persons allowed on a roster",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"overtimeAllowed"}
            label={formatMessage({
              id: "overtime.allowed",
              defaultMessage: "overtimeAllowed",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.overtime.allowed",
              defaultMessage: "Is overtime allowed?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"overtimeLength"}
            label={formatMessage({
              id: "overtime.length",
              defaultMessage: "overtimeLength",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.overtime",
              defaultMessage: "The length (in minutes) of an overtime period",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"timeoutsPerMatch"}
            label={formatMessage({
              id: "number.of.match.timeouts",
              defaultMessage: "Number of Match Timeouts",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.number.of.match.timeouts",
              defaultMessage: "How many timeouts per team for each match?",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"maximumPlayersOnField"}
            label={formatMessage({
              id: "maximum.players.on.field",
              defaultMessage: "Maximum players on field",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.max.players.on.field",
              defaultMessage: "The maximum number of players on the field per team",
            })}
            rules={[
              ({ getFieldValue }) =>
                createMaxPlayersValidator(getFieldValue, formatMessage, "form.matchProfile.error.maximumPlayersOnField"),
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"shotsUntilSuddenDeath"}
            label={formatMessage({
              id: "shots.until.sudden.death",
              defaultMessage: "Shots until sudden death",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.shots.until.sudden.death",
              defaultMessage:
                "The number of shots each team takes in the shootout before it moves to sudden death phase",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"tiebreakType"}
            label={formatMessage({
              id: "tiebreak.type",
              defaultMessage: "Tiebreak type",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.tiebreak.type",
              defaultMessage: "The tiebreak format for a match (penalties or shootout)",
            })}
          >
            <Select>
              <Select.Option value={null}>-</Select.Option>
              <Select.Option value={"Shootout"}>
                {formatMessage({
                  id: "shootout",
                  defaultMessage: "Shootout",
                })}
              </Select.Option>
              <Select.Option value={"Penalties"}>
                {formatMessage({
                  id: "penalties",
                  defaultMessage: "Penalties",
                })}
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"shootoutSeconds"}
            label={formatMessage({
              id: "shootout.tiebreaker",
              defaultMessage: "Shootout tiebreaker (sec)",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.shootout.tie.breaker",
              defaultMessage: "How many seconds for each shootout shot in the tiebreaker?",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"warmupSeconds"}
            label={formatMessage({
              id: "warm.up.minutes",
              defaultMessage: "Warm up minutes",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.warm.up",
              defaultMessage: "How many minutes for the warmup countdown clock",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"shootoutSecondsCountdown"}
            label={formatMessage({
              id: "shootout.minutes",
              defaultMessage: "Shootout minutes",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.shootout",
              defaultMessage: "How many minutes for the shootout countdown clock?",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"countdownTimer"}
            label={formatMessage({
              id: "сountdown.seconds",
              defaultMessage: "Сountdown seconds",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.countdown",
              defaultMessage: "How many seconds for the penalty corner / Goal countdown timer?",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"greenCardSeconds"}
            label={formatMessage({
              id: "green.card.minutes",
              defaultMessage: "Green card minutes",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.green.card",
              defaultMessage: "How many minutes for a Green Card?",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"yellowCardSeconds"}
            label={formatMessage({
              id: "yellow.card.minutes",
              defaultMessage: "Yellow card minutes",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.yellow.card",
              defaultMessage: "How many minutes for a Yellow Card?",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"videoReviewAllowed"}
            label={formatMessage({
              id: "videoReviewAllowed",
              defaulMessage: "Video Review",
            })}
            tooltip={formatMessage({
              id: "videoReviewAllowed",
              defaultMessage: "Is video review allowed?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        {/*TODO add field description*/}
        <Col span={8}>
          <MatchProfileNumberFormInput
            name={"shirtNumberMinimum"}
            label={formatMessage({
              id: "match.profile.shirtNumberMinimum",
              defaultMessage: "Shirt No. Min",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
          <MatchProfileNumberFormInput
            name={"shirtNumberMaximum"}
            label={formatMessage({
              id: "match.profile.shirtNumberMaximum",
              defaultMessage: "Shirt No. Max",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"switchPlayingDirection"}
            label={formatMessage({
              id: "switch.play.direction",
              defaultMessage: "Switch direction of play after period/s",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.switch.play.direction",
              defaultMessage: "Switch direction of play after period/s",
            })}
          >
            <Checkbox.Group options={checkboxOptions}></Checkbox.Group>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default HockeyForm;
